import useTranslation from "@hooks/use_translation.ts";
import SectionDetailList from "@components/profile/section_detail_list.tsx";
import type { ProfileData } from "@/queries/use_profile.ts";
import type { Websites } from "@components/quick_apply/websites";

type Props = { data: ProfileData };

const WEBSITE_KEYS: (keyof Websites)[] = ["linkedin", "github", "portfolio", "website"];

const OnlineProfilesBody = ({ data }: Props) => {
  const { t } = useTranslation("user");

  return (
    <SectionDetailList
      rows={WEBSITE_KEYS.map((key) => ({
        label: t(`website.${key}`),
        value: data.websites?.[key],
      }))}
    />
  );
};

export default OnlineProfilesBody;
